function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  y: 0.5,
  width: 24,
  height: 24,
  fill: "#D9D9D9"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_4137_11018)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.55028 17.8073L4.58105 12.8381L5.2945 12.1246L9.55028 16.3804L18.7061 7.22461L19.4195 7.93806L9.55028 17.8073Z",
  fill: "currentColor"
}));

function SvgIconCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4137_11018",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _ref), _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.4d7127650924b5b79aef99bc4836bbec.svg";
export { ForwardRef as ReactComponent };